<template>
  <div>
    <el-drawer
      title="Formularios Solicitados"
      :visible.sync="showDrawerPermissionReport"
      size="1000px"
      :before-close="closeDrawerDetalles"
      @closed="closeDrawerDetalles"
    >
      <rabbey-table-3
        :columns="ColumnsDetalles2"
        :data="PermissionData"
        :actions="actions"
        :loading="autoLoading"
        @rtable-push-action="onPushAction"
      ></rabbey-table-3>
    </el-drawer>
    <DrawerPermission
      ref="permissionForm"
      :visible.sync="vacacionDrawer"
      @dialog-closed="getDataForMonth(UserId, Month, year, type)"
      @update-data="onPushAction(actionRowData)"
    ></DrawerPermission>
  </div>
</template>

<script>
import {
  permissionOrLinceseColumns,
  absenceColumns
} from "@/views/apps/employees/RRHH/Modules/Permission/columns/ColumnsPermissionForMonth.js";
import DrawerPermission from "@/views/apps/employees/RRHH/Modules/Permission/DrawerPermission.vue";
import Vue from "vue";

const vue = new Vue();
export default {
  name: "PermissionsReportForMes.vue",
  components: {
    DrawerPermission
  },
  data() {
    return {
      ColumnsDetalles2: permissionOrLinceseColumns,
      PermissionData: [],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view-task-view"
        },
        {
          icon: "el-icon-edit",
          label: "Editar",
          command: "edit-task-edit",
          condition: (row) =>
            (this.type == "Absence" &&
              this.currentUser.PositionID == 68 &&
              row.RRHH_Approval == "Pendiente" &&
              row.SupervisorApproval == "Pendiente") ||
            (this.type != "Absence" &&
              row.IdEmployee == this.currentUser.EmployeeId &&
              row.RRHH_Approval == "Pendiente" &&
              row.SupervisorApproval == "Pendiente")
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete-task-delete",
          condition: (row) =>
            (this.type == "Absence" &&
              this.currentUser.PositionID == 68 &&
              row.RRHH_Approval == "Pendiente" &&
              row.SupervisorApproval == "Pendiente") ||
            (this.type != "Absence" &&
              row.IdEmployee == this.currentUser.EmployeeId &&
              row.RRHH_Approval == "Pendiente" &&
              row.SupervisorApproval == "Pendiente")
        },
        {
          icon: "el-icon-check",
          label: "Supervisor Aprobación",
          command: "approve-task",
          condition: (row) =>
            row.SupervisorApproval == "Pendiente" &&
            row.IdSupervisor == this.currentUser.EmployeeId &&
            this.type != "Absence"
        },
        {
          icon: "el-icon-check",
          label: "RRHH Aprobación",
          command: "approve-task-rrhh",
          condition: (row) =>
            row.RRHH_Approval == "Pendiente" &&
            (this.currentUser.PositionID == 68 ||
              this.currentUser.PositionID == 129) &&
            this.type != "Absence"
        },
        {
          icon: "el-icon-close",
          label: "Supervisor Rechazo",
          command: "rejected-task",
          condition: (row) =>
            row.SupervisorApproval == "Pendiente" &&
            row.IdSupervisor == this.currentUser.EmployeeId &&
            this.type != "Absence"
        },
        {
          icon: "el-icon-close",
          label: "RRHH Rechazo",
          command: "rejected-task-rrhh",
          condition: (row) =>
            row.RRHH_Approval == "Pendiente" &&
            (this.currentUser.PositionID == 68 ||
              this.currentUser.PositionID == 129) &&
            this.type != "Absence"
        },
        {
          icon: "el-icon-finished",
          label: "Ejecucion Permiso",
          command: "execute-task-rrhh",
          condition: (row) =>
            row.RRHH_Approval == "Aprobado" &&
            row.SupervisorApproval == "Aprobado" &&
            (this.currentUser.PositionID == 68 ||
              this.currentUser.PositionID == 129) &&
            this.type != "Absence"
        }
      ],
      vacacionDrawer: false,
      actionRowData: false,
      autoLoading: false
    };
  },
  props: {
    showDrawerPermissionReport: {
      type: Boolean,
      default: false
    },
    UserId: {
      type: Number,
      default: 0
    },
    Month: {
      type: Number,
      default: 0
    },
    year: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ""
    }
  },
  mounted() {
    this.ColumnsDetalles2 =
      this.type != "Absence" ? permissionOrLinceseColumns : absenceColumns;
  },
  watch: {
    showDrawerPermissionReport(v) {
      if (v == true) {
        this.getDataForMonth(this.UserId, this.Month, this.year, this.type);
      }
    }
  },
  methods: {
    getDataForMonth(employee = null, month = null, year = null, type = null) {
      this.autoLoading = true;
      let params = {
        EmployeeID: employee,
        Month: month,
        year: year,
        type: type
      };
      this.$http
        .get("/api/Modules/GetPermissionsListByMonth", { params })
        .then((resp) => {
          this.PermissionData = resp.data;
        })
        .finally(() => {
          this.autoLoading = false;
        });
    },

    closeDrawerDetalles() {
      this.$emit("dialog-closed");
    },

    async onPushAction(action) {
      this.actionRowData = action;
      let rowFormInfo;
      if (action.row.IdRequest) {
        let params = {
          IdRequest: action.row.IdRequest
        };
        this.$http
          .get("/api/Modules/GetPermissionById", { params })
          .then((resp) => {
            rowFormInfo = resp.data;
          })
          .finally(() => {
            this.autoLoading = false;
          });
      }

      this.vacacionDrawer = true;

      let rowData = {
        task: action.row,
        rowforminfo: rowFormInfo
      };

      switch (action.command) {
        case "view-task-view":
          this.$refs.permissionForm.show(rowData, true, false, false);
          break;
        case "edit-task-edit":
          this.$refs.permissionForm.show(rowData, false, false, true);
          break;
        case "delete-task-delete":
          this.$refs.permissionForm.DelelePermissionRequest(rowData);
          break;

        case "approve-task":
          await this.SupervisorApproved(rowData.task);
          break;

        case "approve-task-rrhh":
          await this.RRHHApproved(rowData.task);
          break;

        case "rejected-task-rrhh":
          await this.RRHHRejected(rowData.task);
          break;

        case "rejected-task":
          await this.SupervisorRejected(rowData.task);
          break;

        case "execute-task-rrhh":
          await this.RRHHExecuted(rowData.task);
          break;
      }
    },

    async SupervisorApproved(row) {
      let FormId = row.IdRequest;
      let reponsable = row.IdEmployee;
      let userApproved = this.currentUser.EmployeeId;
      let updated = false;

      this.$confirm(
        "Estas seguro que deseas aprobar esta solicitud. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.autoLoading = true;
          this.$http
            .get("/api/Modules/SupervisorApprovedPermission?", {
              params: {
                IdRequest: FormId,
                ResponsableId: reponsable,
                EmployeeID: userApproved,
                Type: this.type
              }
            })
            .then(() => {
              vue.$message({
                message: "Solicitud Aprobada Exitosamente",
                type: "success"
              });
              updated = true;
            })
            .catch((err) => {
              vue.$message({ type: "danger", message: err });
            })
            .finally(() => {
              this.getDataForMonth(
                this.UserId,
                this.Month,
                this.year,
                this.type
              );
              this.$emit("refreshTable2");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Confirmacion cancelada"
          });
        });
      if (updated) {
        return row;
      }
    },

    async SupervisorRejected(row) {
      let FormId = row.IdRequest;
      let reponsable = row.IdEmployee;
      let userApproved = this.currentUser.EmployeeId;
      let updated = false;

      this.$confirm(
        "Estas seguro que deseas rechazar esta solicitud. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          showInput: true,
          inputPlaceholder: "Ingresar comentario de rechazo"
        }
      )
        .then((rejection_comment) => {
          //console.log("super_rejection_comment: ", rejection_comment)
          this.autoLoading = true;
          this.$http
            .get("/api/Modules/SupervisorRejectedPermission?", {
              params: {
                IdRequest: FormId,
                ResponsableId: reponsable,
                EmployeeID: userApproved,
                Type: this.type,
                rejection_comment: rejection_comment.value
              }
            })
            .then(() => {
              vue.$message({
                message: "Solicitud Rechazada Exitosamente",
                type: "success"
              });
              updated = true;
            })
            .catch((err) => {
              vue.$message({ type: "danger", message: err });
            })
            .finally(() => {
              this.getDataForMonth(
                this.UserId,
                this.Month,
                this.year,
                this.type
              );
              this.$emit("refreshTable2");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Confirmacion cancelada"
          });
        });
      if (updated) {
        return row;
      }
    },

    async RRHHApproved(row) {
      let FormId = row.IdRequest;
      let reponsable = row.IdEmployee;
      let userApproved = this.currentUser.EmployeeId;
      let updated = false;

      this.$confirm(
        "Estas seguro que deseas aprobar esta solicitud. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.autoLoading = true;
          this.$http
            .get("/api/Modules/RRHHApprovedPermission?", {
              params: {
                IdRequest: FormId,
                ResponsableId: reponsable,
                EmployeeID: userApproved,
                Type: this.type
              }
            })
            .then(() => {
              vue.$message({
                message: "Solicitud Aprobada Exitosamente RRHH",
                type: "success"
              });
              updated = true;
            })
            .catch((err) => {
              vue.$message({ type: "danger", message: err });
            })
            .finally(() => {
              this.getDataForMonth(
                this.UserId,
                this.Month,
                this.year,
                this.type
              );
              this.$emit("refreshTable2");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Confirmacion cancelada"
          });
        });
      if (updated) {
        return row;
      }
    },
    async RRHHRejected(row) {
      let FormId = row.IdRequest;
      let reponsable = row.IdEmployee;
      let userApproved = this.currentUser.EmployeeId;
      let updated = false;

      this.$confirm(
        "Estas seguro que deseas rechazar esta solicitud. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
          showInput: true,
          inputPlaceholder: "Ingresar comentario de rechazo"
        }
      )
        .then((rejection_comment) => {
          //console.log("RH_rejection_comment: ", rejection_comment)
          this.autoLoading = true;
          this.$http
            .get("/api/Modules/RRHHRejectedPermission?", {
              params: {
                IdRequest: FormId,
                ResponsableId: reponsable,
                EmployeeID: userApproved,
                Type: this.type,
                rejection_comment: rejection_comment.value
              }
            })
            .then(() => {
              vue.$message({
                message: "Solicitud Rechazada Exitosamente RRHH",
                type: "success"
              });
              updated = true;
            })
            .catch((err) => {
              vue.$message({ type: "danger", message: err });
            })
            .finally(() => {
              this.getDataForMonth(
                this.UserId,
                this.Month,
                this.year,
                this.type
              );
              this.$emit("refreshTable2");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Confirmacion cancelada"
          });
        });
      if (updated) {
        return row;
      }
    },

    async RRHHExecuted(row) {
      let FormId = row.IdRequest;
      let reponsable = row.IdEmployee;
      let userApproved = this.currentUser.EmployeeId;
      let updated = false;

      this.$confirm(
        "Estas seguro que deseas ejecutar esta solicitud. Continue?",
        "Warning",
        {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning"
        }
      )
        .then(() => {
          this.autoLoading = true;
          this.$http
            .get("/api/Modules/RRHHRExecutedPermission?", {
              params: {
                IdRequest: FormId,
                ResponsableId: reponsable,
                EmployeeID: userApproved,
                Type: this.type
              }
            })
            .then(() => {
              vue.$message({
                message: "Permiso en ejecucion",
                type: "success"
              });
              updated = true;
            })
            .catch((err) => {
              vue.$message({ type: "danger", message: err });
            })
            .finally(() => {
              this.getDataForMonth(
                this.UserId,
                this.Month,
                this.year,
                this.type
              );
              this.$emit("refreshTable2");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Confirmacion cancelada"
          });
        });
      if (updated) {
        return row;
      }
    }
  }
};
</script>
